import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { I18nService } from '../../core/services/i18n.service';


export interface CvcValidationErrors extends ValidationErrors {
  invalidFormat?: { message: string };
  invalidLength?: { message: string };
}

export function cvcValidator(i18nService: I18nService): ValidatorFn {
  return (control: AbstractControl): CvcValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const value = control.value.toString().trim();
    
    // Verifica se contém apenas números
    if (!/^\d+$/.test(value)) {
      return { 
        invalidFormat: { 
          message: i18nService.instant('validators.cvc.invalidFormat') 
        } 
      };
    }

    // Verifica se tem 3 ou 4 dígitos
    if (value.length < 3 || value.length > 4) {
      return { 
        invalidLength: { 
          message: i18nService.instant('validators.cvc.invalidLength')
        } 
      };
    }

    return null;
  };
}